/**
 *
 * @author Iecisa
 */
export class PolicyParamDTO {

    pageOffset: Number;
    pageSize: Number;
    startDate: string;
    endDate: string;
    policyNumber: string;
    policyCollective: string;
    statusType: any[];
    product: any[];
    policyItems: any[];
    isTaker: boolean;

}
